import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex"
};
const _hoisted_2 = {
  class: "bg-gray-100 p-8 lg:w-[50%] md:w-[60%] sm:w-[70%] main-table-view"
};
const _hoisted_3 = {
  class: "bg-white flex flex-col p-4"
};
const _hoisted_4 = {
  class: "pl-4 pt-4 lg:w-[50%] md:w-[40%] sm:w-[30%] bg-white"
};
const _hoisted_5 = {
  class: "flex items-center justify-start pt-4"
};
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-2 flex flex-col justify-between"
};
const _hoisted_7 = {
  class: "click-menu"
};
const _hoisted_8 = {
  class: "flex justify-between px-4 py-2"
};
const _hoisted_9 = {
  key: 0,
  class: "menu"
};
const _hoisted_10 = {
  class: "bg-white shadow-xl rounded absolute px-2 py-3 w-52 z-10 action-menu custom-border border at-action-menu"
};
const _hoisted_11 = {
  class: "cursor-pointer flex"
};
const _hoisted_12 = {
  style: {
    "margin": "1px"
  }
};
const _hoisted_13 = {
  class: "flex flex-col px-4 pb-4"
};
const _hoisted_14 = {
  scope: "col"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "click-menu"
};
const _hoisted_17 = {
  class: "flex justify-between px-4 py-2"
};
const _hoisted_18 = {
  key: 0,
  class: "menu"
};
const _hoisted_19 = {
  class: "bg-white shadow-xl rounded absolute px-2 py-3 w-52 z-10 action-menu custom-border border at-action-menu"
};
const _hoisted_20 = {
  class: "cursor-pointer flex"
};
const _hoisted_21 = {
  style: {
    "margin": "1px"
  }
};
const _hoisted_22 = {
  class: "flex flex-col px-4 pb-4"
};
const _hoisted_23 = {
  scope: "col"
};
const _hoisted_24 = {
  class: "fab-container gap-2"
};
import { storeToRefs } from 'pinia';
import draggable from 'vuedraggable';
import LlCheckbox from '@/components/LlCheckbox.vue';
import { onMounted, reactive, ref, computed } from 'vue';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import { updateOrder } from '@/services/utils';
import DataTable from './DataTable.vue';

// Components
import Loader from '@/components/Loader.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import InvoiceTableLogoAndHeader from '../InvoiceTableLogoAndHeader.vue';
export default {
  __name: 'UpdateServiceExpenseByMatterPage',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  emits: ['closeDialog'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      getServiceAndExpenseTableFields,
      updateServiceExpenseByMatterTableFields,
      getCustomFields,
      addCustomFieldsData,
      expenseDataByMatterPage
    } = useInvoiceTemplateStore();
    const {
      serviceAndExpenseTableFields,
      customFields,
      servicesAndExpenseByMatter,
      expenseTableDataByMatterPage
    } = storeToRefs(useInvoiceTemplateStore());
    const props = __props;
    let debounceTimer = null;
    const updatePdfState = reactive({
      loading: false,
      showSortableModel: false,
      disabledTableFieldsForSingleInvoice: [],
      disabledTableFieldsForMultiInvoice: [],
      tableFieldsForSingleInvoice: [],
      tableFieldsForMultiInvoice: []
    });
    const templateOptions = [{
      label: 'Single Invoice',
      value: 'singleInvoice'
    }, {
      label: 'Multi-Invoice',
      value: 'multiInvoice'
    }];
    const selectedTemplate = ref('singleInvoice');
    const emit = __emit;
    const isSingleInvoice = computed(() => selectedTemplate.value === 'singleInvoice');
    const currentTableFields = computed(() => isSingleInvoice.value ? updatePdfState.tableFieldsForSingleInvoice : updatePdfState.tableFieldsForMultiInvoice);
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      updatePdfState.loading = true;
      await Promise.all([getServiceAndExpenseTableFields(), getCustomFields(), expenseDataByMatterPage()]);
      const tableHeaderForSingleInvoice = [...serviceAndExpenseTableFields.value, ...customFields.value]?.filter(field => field.fieldName !== 'InvoiceNumber');
      const tableHeaderForMultiInvoice = [...serviceAndExpenseTableFields.value, ...customFields.value];
      if (customFields.value.length) {
        addCustomFieldsData();
      }
      const {
        enabledFields: enabledTableFields,
        disabledFields: disabledTableFields
      } = updateFieldSettings(tableHeaderForSingleInvoice, servicesAndExpenseByMatter.value.tableFieldSettings);
      const {
        enabledFields: enabledMultiInvoiceTableFields,
        disabledFields: disabledMultiInvoiceTableFields
      } = updateFieldSettings(tableHeaderForMultiInvoice, servicesAndExpenseByMatter.value.multiInvoiceTableFieldSettings);
      updatePdfState.tableFieldsForSingleInvoice = enabledTableFields;
      updatePdfState.disabledTableFieldsForSingleInvoice = disabledTableFields;
      updatePdfState.tableFieldsForMultiInvoice = enabledMultiInvoiceTableFields;
      updatePdfState.disabledTableFieldsForMultiInvoice = disabledMultiInvoiceTableFields;
      updatePdfState.loading = false;
    });
    const toggleShowSortableModel = () => {
      updatePdfState.showSortableModel = !updatePdfState.showSortableModel;
    };
    const handleClickOutside = event => {
      const actionMenuContainer = document.querySelector('.click-menu');
      if (!actionMenuContainer || actionMenuContainer.contains(event.target)) {
        // Click was inside the action menu container, do nothing
        return;
      }
      // Click was outside the action menu, close it
      updatePdfState.showSortableModel = false;
    };
    const toggleTableFieldsList = fields => {
      if (fields.isDefault) {
        fields.isEnabled = true;
        props.alerts.error(`You cannot disable the ${fields.displayName} field`);
        return;
      }
      if (!fields.isEnabled) {
        updatePdfState.disabledTableFieldsForSingleInvoice.unshift({
          ...fields,
          isEnabled: false
        });
        updatePdfState.tableFieldsForSingleInvoice = updatePdfState.tableFieldsForSingleInvoice.filter(field => field.tableFieldId !== fields.tableFieldId || field.customFieldId !== fields.customFieldId);
      } else {
        if (updatePdfState.tableFieldsForSingleInvoice.length >= 5) {
          fields.isEnabled = false;
          props.alerts.error('You can only select up to 5 fields');
          return;
        }
        updatePdfState.tableFieldsForSingleInvoice.unshift({
          order: updatePdfState.tableFieldsForSingleInvoice.length + 1,
          ...fields,
          isEnabled: true
        });
        updatePdfState.disabledTableFieldsForSingleInvoice = updatePdfState.disabledTableFieldsForSingleInvoice.filter(field => field.tableFieldId !== fields.tableFieldId || field.customFieldId !== fields.customFieldId);
      }
    };
    const toggleTableFieldsForMultiInvoice = fields => {
      if (fields.isDefault) {
        fields.isEnabled = true;
        props.alerts.error(`You cannot disable the ${fields.displayName} field`);
        return;
      }
      if (!fields.isEnabled) {
        updatePdfState.disabledTableFieldsForMultiInvoice.unshift({
          ...fields,
          isEnabled: false
        });
        updatePdfState.tableFieldsForMultiInvoice = updatePdfState.tableFieldsForMultiInvoice.filter(field => field.tableFieldId !== fields.tableFieldId || field.customFieldId !== fields.customFieldId);
      } else {
        if (updatePdfState.tableFieldsForMultiInvoice.length >= 6) {
          fields.isEnabled = false;
          props.alerts.error('You can only select up to 6 fields');
          return;
        }
        updatePdfState.tableFieldsForMultiInvoice.splice(1, 0, {
          order: updatePdfState.tableFieldsForMultiInvoice.length + 1,
          ...fields,
          isEnabled: true
        });
        updatePdfState.disabledTableFieldsForMultiInvoice = updatePdfState.disabledTableFieldsForMultiInvoice.filter(field => field.tableFieldId !== fields.tableFieldId || field.customFieldId !== fields.customFieldId);
      }
    };
    const updateFieldSettings = (fieldsList, settingsList) => {
      const enabledFields = fieldsList.filter(field => settingsList?.some(setting => {
        // Automatically detect and match either tableFieldId or customFieldId
        const key = setting.tableFieldId ? 'tableFieldId' : 'customFieldId';
        return setting[key] === field[key];
      })).map(field => {
        const setting = settingsList.find(setting => {
          const key = setting.tableFieldId ? 'tableFieldId' : 'customFieldId';
          return setting[key] === field[key];
        });
        return {
          ...field,
          isEnabled: true,
          order: setting.order
        };
      }).sort((a, b) => a.order - b.order);
      const disabledFields = fieldsList.filter(field => !enabledFields.some(enabledField => {
        // Determine the matching key dynamically
        const key = field.tableFieldId ? 'tableFieldId' : 'customFieldId';
        return enabledField[key] === field[key];
      }));
      return {
        enabledFields,
        disabledFields
      };
    };
    const saveTemplate = () => {
      const tableFieldSettings = updateOrder(updatePdfState.tableFieldsForSingleInvoice);
      const multiInvoiceTableFieldSettings = updateOrder(updatePdfState.tableFieldsForMultiInvoice);
      const isCloseDialog = updateServiceExpenseByMatterTableFields(tableFieldSettings, multiInvoiceTableFieldSettings);
      if (isCloseDialog) emit('closeDialog', true);
    };
    const onMove = evt => {
      if (debounceTimer) {
        return false;
      }
      debounceTimer = setTimeout(() => {
        debounceTimer = null;
      }, 250);
      if (evt.draggedContext.element.isDefault) {
        props.alerts.error(`You cannot move ${evt.draggedContext.element.displayName} from this position`);
        return false;
      }
      if (isSingleInvoice.value) {
        if (!evt.draggedContext.element.isDefault && [2, 3, 4].includes(evt.relatedContext.index)) {
          props.alerts.error(`You cannot move ${evt.draggedContext.element.displayName} right of this position`);
          return false;
        }
      } else {
        if (!evt.draggedContext.element.isDefault && [0, 3, 4, 5].includes(evt.relatedContext.index)) {
          props.alerts.error(`You cannot move ${evt.draggedContext.element.displayName} right of this position`);
          return false;
        }
      }
      return true;
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "p-4 overflow-hidden bg-gray-200"
      }, {
        default: _withCtx(() => [updatePdfState.loading ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          what: "Services & Expenses Summary by Matter",
          class: "my-8"
        })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(InvoiceTableLogoAndHeader), _cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "py-2 text-sm font-semibold"
        }, " Services & Expenses Summary by Matter ", -1)), _createVNode(DataTable, {
          headers: currentTableFields.value,
          rows: _unref(expenseTableDataByMatterPage)
        }, null, 8, ["headers", "rows"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlButtonToggle, {
          modelValue: selectedTemplate.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedTemplate.value = $event),
          items: templateOptions,
          "aria-label": "Invoice layout"
        }, null, 8, ["modelValue"])]), isSingleInvoice.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "text-base"
        }, "Table Fields", -1)), _createVNode(LlSecondaryButton, {
          variant: "flat",
          "prepend-icon": "mdi-filter-variant",
          onClick: _cache[1] || (_cache[1] = $event => toggleShowSortableModel())
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Columns ", -1)]))]),
          _: 1
        })]), updatePdfState.showSortableModel ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(draggable), {
          modelValue: updatePdfState.tableFieldsForSingleInvoice,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updatePdfState.tableFieldsForSingleInvoice = $event),
          group: "people",
          onStart: _cache[3] || (_cache[3] = $event => _ctx.drag = true),
          onEnd: _cache[4] || (_cache[4] = $event => _ctx.drag = false),
          move: onMove,
          "item-key": "fieldName"
        }, {
          item: _withCtx(({
            element
          }) => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_v_icon, {
            class: "pt-1.5"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("mdi-drag", -1)]))]),
            _: 1
          }), _createVNode(LlCheckbox, {
            modelValue: element.isEnabled,
            "onUpdate:modelValue": $event => element.isEnabled = $event,
            disabled: element.isDefault,
            label: element.displayName,
            onCheckboxClick: $event => toggleTableFieldsList(element)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "label", "onCheckboxClick"])])]),
          _: 1
        }, 8, ["modelValue"]), _withDirectives(_createElementVNode("hr", _hoisted_12, null, 512), [[_vShow, updatePdfState.disabledTableFieldsForSingleInvoice?.length]]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updatePdfState.disabledTableFieldsForSingleInvoice, (fields, idx) => {
          return _openBlock(), _createElementBlock("div", {
            key: idx,
            class: "flex felx-row"
          }, [_cache[17] || (_cache[17] = _createElementVNode("span", {
            class: "px-2.5"
          }, null, -1)), _createVNode(LlCheckbox, {
            modelValue: fields.isEnabled,
            "onUpdate:modelValue": $event => fields.isEnabled = $event,
            label: fields.displayName,
            onCheckboxClick: $event => toggleTableFieldsList(fields)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])]);
        }), 128))])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createVNode(_unref(draggable), {
          modelValue: updatePdfState.tableFieldsForSingleInvoice,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updatePdfState.tableFieldsForSingleInvoice = $event),
          tag: "tr",
          class: "overflow-x-auto",
          "item-key": key => key,
          move: onMove
        }, {
          item: _withCtx(({
            element: header
          }) => [_createElementVNode("th", _hoisted_14, [_createVNode(_component_v_chip, {
            class: "mx-1 cursor-pointer",
            label: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(header.displayName), 1)]),
            _: 2
          }, 1024)])]),
          _: 1
        }, 8, ["modelValue", "item-key"])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-base"
        }, "Table Fields", -1)), _createVNode(LlSecondaryButton, {
          variant: "flat",
          "prepend-icon": "mdi-filter-variant",
          onClick: _cache[6] || (_cache[6] = $event => toggleShowSortableModel())
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Columns ", -1)]))]),
          _: 1
        })]), updatePdfState.showSortableModel ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_unref(draggable), {
          modelValue: updatePdfState.tableFieldsForMultiInvoice,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updatePdfState.tableFieldsForMultiInvoice = $event),
          group: "people",
          onStart: _cache[8] || (_cache[8] = $event => _ctx.drag = true),
          onEnd: _cache[9] || (_cache[9] = $event => _ctx.drag = false),
          move: onMove,
          "item-key": "fieldName"
        }, {
          item: _withCtx(({
            element
          }) => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_v_icon, {
            class: "pt-1.5"
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("mdi-drag", -1)]))]),
            _: 1
          }), _createVNode(LlCheckbox, {
            modelValue: element.isEnabled,
            "onUpdate:modelValue": $event => element.isEnabled = $event,
            disabled: element.isDefault,
            label: element.displayName,
            onCheckboxClick: $event => toggleTableFieldsForMultiInvoice(element)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "label", "onCheckboxClick"])])]),
          _: 1
        }, 8, ["modelValue"]), _withDirectives(_createElementVNode("hr", _hoisted_21, null, 512), [[_vShow, updatePdfState.disabledTableFieldsForMultiInvoice?.length]]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updatePdfState.disabledTableFieldsForMultiInvoice, (fields, idx) => {
          return _openBlock(), _createElementBlock("div", {
            key: idx,
            class: "flex felx-row"
          }, [_cache[21] || (_cache[21] = _createElementVNode("span", {
            class: "px-2.5"
          }, null, -1)), _createVNode(LlCheckbox, {
            modelValue: fields.isEnabled,
            "onUpdate:modelValue": $event => fields.isEnabled = $event,
            label: fields.displayName,
            onCheckboxClick: $event => toggleTableFieldsForMultiInvoice(fields)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])]);
        }), 128))])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_createVNode(_unref(draggable), {
          modelValue: updatePdfState.tableFieldsForMultiInvoice,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => updatePdfState.tableFieldsForMultiInvoice = $event),
          tag: "tr",
          class: "overflow-x-auto",
          "item-key": key => key,
          move: onMove
        }, {
          item: _withCtx(({
            element: header
          }) => [_createElementVNode("th", _hoisted_23, [_createVNode(_component_v_chip, {
            class: "mx-1 cursor-pointer",
            label: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(header.displayName), 1)]),
            _: 2
          }, 1024)])]),
          _: 1
        }, 8, ["modelValue", "item-key"])])])])), _createElementVNode("div", _hoisted_24, [_createVNode(LlSecondaryButton, {
          variant: "outlined",
          onBtnClick: _cache[11] || (_cache[11] = $event => _ctx.$emit('closeDialog', false))
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" Close ", -1)]))]),
          _: 1
        }), _createVNode(LlSecondaryButton, {
          color: "primary",
          onBtnClick: _cache[12] || (_cache[12] = $event => saveTemplate())
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("Save Template", -1)]))]),
          _: 1
        })])])]))]),
        _: 1
      });
    };
  }
};